<template>
  <user-list :type="1" />
</template>

<script>
import UserList from '@/components/user/List.vue'

export default {
  name: 'ViewAdminList',

  components: { UserList }
}
</script>
